var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.messages && _vm.abgeschlossen)?_c('div',{staticClass:"isAbgeschlossenWrapper"},[_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.messages['fh.header.isAbgeschlossen'])}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }